import { i18next } from '@yola/ws-sdk';
import common from '../constants/common';

const validateKeywords = (value) => {
  if (value && value.length > common.MAX_KEYWORDS_COUNT) {
    return i18next.t('Maximum number of keywords is 100', {
      count: common.MAX_KEYWORDS_COUNT,
    });
  }

  return null;
};

export default validateKeywords;
